import { render, staticRenderFns } from "./QueryStatsItem.vue?vue&type=template&id=124f7572"
import script from "./QueryStatsItem.vue?vue&type=script&lang=ts"
export * from "./QueryStatsItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports